import { SVGProps } from 'react';

const HistoryClock = ({
  height,
  color = 'var(--secondaryText)',
  fill = 'currentColor',
  ...props
}: SVGProps<SVGSVGElement>) => {
  return (
    (<svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height={height ?? 22}
      viewBox="0 0 22 22"
      color={color}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
      data-palette="HistoryClock">
      <g fill="none" fillRule="evenodd">
        <g>
          <g>
            <path
              d="M0 0L22 0 22 22 0 22z"
              transform="translate(-336 -13) translate(336 13)"
            />
            <path
              fill={fill}
              fillRule="nonzero"
              d="M11 1.833c5.063 0 9.167 4.104 9.167 9.167S16.063 20.167 11 20.167 1.833 16.063 1.833 11h1.834c0 4.05 3.283 7.333 7.333 7.333 4.05 0 7.333-3.283 7.333-7.333 0-4.05-3.283-7.333-7.333-7.333-2.52 0-4.745 1.271-6.064 3.208h2.397v1.833h-5.5v-5.5h1.834V5.5C5.339 3.272 8.002 1.833 11 1.833zm.917 4.584v4.203l2.972 2.972-1.297 1.297-3.509-3.51V6.417h1.834z"
              transform="translate(-336 -13) translate(336 13)"
            />
          </g>
        </g>
      </g>
    </svg>)
  );
};

export default HistoryClock;
